"use strict";
var _VideoClientErrorDeprecated_message, _VideoClientErrorDeprecated_ppStack;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerNotFoundError = exports.HlsjsNotLoadedError = exports.InvalidBitrateError = exports.UserRequiredError = exports.UnrecognizedDriverError = exports.UnknownError = exports.UnknownDriverError = exports.PlaybackError = exports.NoDriversError = exports.WSNetworkError = exports.InvalidElementError = exports.InvalidPopoutURLError = exports.InvalidMediaURLError = exports.InvalidControlsError = exports.ManifestNotFoundError = exports.ManifestInternalError = exports.ManifestForbiddenError = exports.ManifestUnauthorizedError = exports.ManifestUnexpectedResponseError = exports.GetUserMediaFailedError = exports.EmbedSWFFailedError = exports.ElementRequiredError = exports.DriverNotSupportedError = exports.ManifestBadInputError = exports.ManifestError = exports.DisableAudioError = exports.DisableVideoError = exports.EnableAudioError = exports.EnableVideoError = exports.StreamNotFoundError = exports.StreamExistsError = exports.UpdateBroadcastError = exports.StartBroadcastError = exports.BroadcastError = exports.JoinCallError = exports.CallError = exports.TrackEndedError = exports.CapturableStreamError = exports.DeviceNotFoundError = exports.ConstraintsError = exports.NetworkError = exports.PermissionsError = exports.InternalCallError = exports.ValidationError = exports.NotSupportedError = exports.NotInitializedError = exports.InternalError = exports.NativeError = exports.VideoClientErrorDeprecated = exports.ErrorCode = void 0;
exports.HandleHlsJsError = exports.Mp4BufferError = exports.ChangeMSCDeviceError = exports.UpdateMSCError = exports.MediaRecorderError = exports.TransportStateError = exports.MediaError = exports.MediasoupSetupError = exports.WSRequestError = exports.SFUProducerResumedEventError = exports.SFUProducerPausedEventError = exports.SFUProducerClosedEventError = exports.SFUConsumerLayersChangedEventError = exports.SFUConsumerScoreEventError = exports.SFUConsumerResumedEventError = exports.SFUConsumerPausedEventError = exports.SFUConsumerClosedEventError = exports.SFUSwitchConsumerTrackEventError = exports.SFUPeerClosedEventError = exports.SFUNewConsumerEventError = exports.SFUConsumerSourcesEventError = exports.SFUNewPeersEventError = exports.RetrievingMediaStreamError = exports.DisposedObjectError = exports.MeowDriverError = exports.PlayingIssueError = exports.ConsumerNotFoundError = void 0;
exports.wrapNativeError = wrapNativeError;
const tslib_1 = require("tslib");
const log_node_1 = require("@video/log-node");
const api_1 = require("../api");
const dom_exception_1 = require("../api/typings/dom-exception");
var api_2 = require("../api");
Object.defineProperty(exports, "ErrorCode", { enumerable: true, get: function () { return api_2.ErrorCode; } });
const excludeFields = new Set([
    "toJSON",
    "ppStack",
    "stack",
    "detailed",
    "handled",
    "inner",
    "aggregates",
]);
function serialize(err) {
    var _a;
    if (err == null) {
        return null;
    }
    if ("toJSON" in err && typeof err.toJSON === "function") {
        return err;
    }
    return {
        err: (_a = err.name) !== null && _a !== void 0 ? _a : err.constructor.name,
        message: err.message,
        stack: err.stack,
    };
}
function wrapNativeError(err) {
    if (err instanceof Error) {
        return new NativeError(err.message, { native: err });
    }
    return new NativeError(String(err), {});
}
const vdcErrPrefix = "Video Client Error: ";
function concatMessages(obj) {
    if (obj == null || typeof obj !== "object" || typeof obj.message !== "string") {
        return "";
    }
    const code = obj.code == null ? "; " : `; [${String(obj.code)} `;
    return `${code}${obj.message}${concatMessages(obj.inner)}`;
}
/**
 * Generic VideoClient error. All errors VDC errors inherits this class
 */
class VideoClientErrorDeprecated extends Error {
    constructor(message, ctx) {
        super();
        this.inner = null;
        _VideoClientErrorDeprecated_message.set(this, void 0);
        _VideoClientErrorDeprecated_ppStack.set(this, null);
        this.handled = false;
        tslib_1.__classPrivateFieldSet(this, _VideoClientErrorDeprecated_message, message, "f");
        const { inner, critical, ...other } = ctx;
        this.inner = inner;
        this.critical = critical !== null && critical !== void 0 ? critical : (inner instanceof VideoClientErrorDeprecated ? inner.critical : false);
        for (const [key, val] of Object.entries(other)) {
            this[key] = val;
        }
    }
    get message() {
        var _a;
        let inMsg = (_a = this.inner) === null || _a === void 0 ? void 0 : _a.message;
        if (inMsg != null) {
            if (inMsg.startsWith(vdcErrPrefix)) {
                inMsg = inMsg.slice(vdcErrPrefix.length);
            }
            return `${vdcErrPrefix}[${this.code}] ${tslib_1.__classPrivateFieldGet(this, _VideoClientErrorDeprecated_message, "f")}; ${inMsg}`;
        }
        if (Reflect.has(this, "err")) {
            return `${vdcErrPrefix}[${this.code}] ${tslib_1.__classPrivateFieldGet(this, _VideoClientErrorDeprecated_message, "f")}${concatMessages(Reflect.get(this, "err"))}`;
        }
        return `${vdcErrPrefix}[${this.code}] ${tslib_1.__classPrivateFieldGet(this, _VideoClientErrorDeprecated_message, "f")}`;
    }
    static async loadPrettyPrintStacktrace(err) {
        // pretty print stacktraces are deprecated and will be removed in the future
        // since it never really worked as expected
        return Promise.resolve();
    }
    static log(err, logger) {
        VideoClientErrorDeprecated.loadPrettyPrintStacktrace(err).finally(() => {
            logger.error(err.message, { err });
        });
    }
    toJSON() {
        var _a, _b;
        const json = {
            message: this.message,
            stack: (_b = (_a = tslib_1.__classPrivateFieldGet(this, _VideoClientErrorDeprecated_ppStack, "f")) !== null && _a !== void 0 ? _a : this.stack) !== null && _b !== void 0 ? _b : null,
            inner: serialize(this.inner),
            aggregates: this.aggregates(),
        };
        for (const k of Object.keys(this)) {
            if (!excludeFields.has(k)) {
                json[k.toString()] = this[k];
            }
        }
        return json;
    }
    aggregates() {
        var _a, _b;
        if (this.inner instanceof VideoClientErrorDeprecated) {
            return {
                ...this.inner.aggregates(),
                errCode: this.code,
                errCritical: (_a = this.critical) !== null && _a !== void 0 ? _a : false,
                errHandled: this.handled,
            };
        }
        return {
            errCode: this.code,
            errCritical: (_b = this.critical) !== null && _b !== void 0 ? _b : false,
            errHandled: this.handled,
        };
    }
}
exports.VideoClientErrorDeprecated = VideoClientErrorDeprecated;
_VideoClientErrorDeprecated_message = new WeakMap(), _VideoClientErrorDeprecated_ppStack = new WeakMap();
class NativeError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.NativeError;
    }
}
exports.NativeError = NativeError;
class InternalError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InternalError;
    }
}
exports.InternalError = InternalError;
class NotInitializedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.NotInitialized;
    }
}
exports.NotInitializedError = NotInitializedError;
class NotSupportedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.NotSupported;
    }
}
exports.NotSupportedError = NotSupportedError;
class ValidationError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ValidationError;
    }
}
exports.ValidationError = ValidationError;
class InternalCallError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InternalCallError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.internalCall),
        };
    }
}
exports.InternalCallError = InternalCallError;
/**
 * Can be thrown if some permissions were declined
 */
class PermissionsError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.Permission;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.stream),
        };
    }
}
exports.PermissionsError = PermissionsError;
/**
 * Generic network error. Can be thrown on any network related issue
 */
class NetworkError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.NetworkError;
    }
    // readonly eventTargetCode?: number;
    aggregates() {
        var _a;
        return { ...super.aggregates(), errStatus: (_a = this.status) !== null && _a !== void 0 ? _a : 0 };
    }
}
exports.NetworkError = NetworkError;
/**
 * Can be thrown when a media request is failed due Constraints error
 */
class ConstraintsError extends VideoClientErrorDeprecated {
    constructor(message, ctx) {
        super(message, ctx);
        this.code = api_1.ErrorCode.Constraints;
        const { inner } = ctx;
        this.failedConstraint = inner != null && (0, dom_exception_1.isOverconstrainedError)(inner) ? inner.constraint : "NA";
    }
}
exports.ConstraintsError = ConstraintsError;
/**
 * Occurred in MediaStreamController when media device not found
 */
class DeviceNotFoundError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.DeviceNotFound;
    }
}
exports.DeviceNotFoundError = DeviceNotFoundError;
class CapturableStreamError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.CapturableStreamError;
    }
}
exports.CapturableStreamError = CapturableStreamError;
/**
 * Can be thrown in MediaStreamController if MediaTrack has ended unexpectedly
 */
class TrackEndedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.TrackEnded;
    }
}
exports.TrackEndedError = TrackEndedError;
/**
 * Generic Call error
 */
class CallError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.CallError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            reason: this.reason,
        };
    }
}
exports.CallError = CallError;
class JoinCallError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.JoinCallError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.call),
        };
    }
}
exports.JoinCallError = JoinCallError;
/**
 * Generic Broadcast error
 */
class BroadcastError extends VideoClientErrorDeprecated {
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.broadcast),
        };
    }
}
exports.BroadcastError = BroadcastError;
class StartBroadcastError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.StartBroadcastError;
    }
}
exports.StartBroadcastError = StartBroadcastError;
class UpdateBroadcastError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UpdateBroadcastError;
    }
}
exports.UpdateBroadcastError = UpdateBroadcastError;
class StreamExistsError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.StreamExists;
    }
}
exports.StreamExistsError = StreamExistsError;
class StreamNotFoundError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.StreamNotFound;
    }
}
exports.StreamNotFoundError = StreamNotFoundError;
class EnableVideoError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.EnableVideoError;
    }
}
exports.EnableVideoError = EnableVideoError;
class EnableAudioError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.EnableAudioError;
    }
}
exports.EnableAudioError = EnableAudioError;
class DisableVideoError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.DisableVideoError;
    }
}
exports.DisableVideoError = DisableVideoError;
class DisableAudioError extends BroadcastError {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.DisableAudioError;
    }
}
exports.DisableAudioError = DisableAudioError;
/**
 * Can be thrown when manifest is not loaded by some reason
 */
class ManifestError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ManifestError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.loader),
        };
    }
}
exports.ManifestError = ManifestError;
class ManifestBadInputError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.BadInput;
    }
}
exports.ManifestBadInputError = ManifestBadInputError;
class DriverNotSupportedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.DriverNotSupported;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.loader),
        };
    }
}
exports.DriverNotSupportedError = DriverNotSupportedError;
class ElementRequiredError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ElementRequired;
    }
}
exports.ElementRequiredError = ElementRequiredError;
class EmbedSWFFailedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.EmbedSWFFailed;
    }
}
exports.EmbedSWFFailedError = EmbedSWFFailedError;
class GetUserMediaFailedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.GetUserMediaFailed;
    }
}
exports.GetUserMediaFailedError = GetUserMediaFailedError;
class ManifestUnexpectedResponseError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ManifestUnexpectedResponse;
    }
}
exports.ManifestUnexpectedResponseError = ManifestUnexpectedResponseError;
class ManifestUnauthorizedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ManifestUnauthorized;
    }
}
exports.ManifestUnauthorizedError = ManifestUnauthorizedError;
class ManifestForbiddenError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ManifestForbidden;
    }
}
exports.ManifestForbiddenError = ManifestForbiddenError;
class ManifestInternalError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ManifestInternalError;
    }
}
exports.ManifestInternalError = ManifestInternalError;
class ManifestNotFoundError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ManifestNotFound;
    }
}
exports.ManifestNotFoundError = ManifestNotFoundError;
class InvalidControlsError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InvalidControls;
    }
}
exports.InvalidControlsError = InvalidControlsError;
class InvalidMediaURLError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InvalidMediaURL;
    }
}
exports.InvalidMediaURLError = InvalidMediaURLError;
class InvalidPopoutURLError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InvalidPopoutURL;
    }
}
exports.InvalidPopoutURLError = InvalidPopoutURLError;
class InvalidElementError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InvalidElement;
    }
}
exports.InvalidElementError = InvalidElementError;
class WSNetworkError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.WSNetworkError;
    }
}
exports.WSNetworkError = WSNetworkError;
class NoDriversError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.NoDrivers;
    }
}
exports.NoDriversError = NoDriversError;
class PlaybackError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.PlaybackError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.loader),
        };
    }
}
exports.PlaybackError = PlaybackError;
class UnknownDriverError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UnknownDriver;
    }
}
exports.UnknownDriverError = UnknownDriverError;
class UnknownError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UnknownError;
    }
}
exports.UnknownError = UnknownError;
class UnrecognizedDriverError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UnrecognizedDriver;
    }
}
exports.UnrecognizedDriverError = UnrecognizedDriverError;
class UserRequiredError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UserRequired;
    }
}
exports.UserRequiredError = UserRequiredError;
class InvalidBitrateError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.InvalidBitrate;
    }
}
exports.InvalidBitrateError = InvalidBitrateError;
class HlsjsNotLoadedError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.HlsjsNotLoaded;
    }
}
exports.HlsjsNotLoadedError = HlsjsNotLoadedError;
/**
 * Can be thrown when unable to get or switch a webrtc layer
 */
class LayerNotFoundError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.LayerNotFound;
    }
}
exports.LayerNotFoundError = LayerNotFoundError;
/**
 * Can be thrown when consumer is not found
 */
class ConsumerNotFoundError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.ConsumerNotFound;
    }
}
exports.ConsumerNotFoundError = ConsumerNotFoundError;
/**
 * Can be thrown when HTMLVideoElement unable to play the stream
 */
class PlayingIssueError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.PlayingIssue;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.player),
        };
    }
}
exports.PlayingIssueError = PlayingIssueError;
class MeowDriverError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.MeowDriverError;
    }
}
exports.MeowDriverError = MeowDriverError;
/**
 * Can be thrown if there was called a method from a disposed object
 */
class DisposedObjectError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.DisposedObject;
    }
}
exports.DisposedObjectError = DisposedObjectError;
/**
 * Can be thrown if MediaStreamController didn't provide MediaStream while supposed to
 */
class RetrievingMediaStreamError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.RetrievingMediaStreamError;
    }
    aggregates() {
        return { ...super.aggregates(), streamName: this.streamName, mediaKind: this.mediaKind };
    }
}
exports.RetrievingMediaStreamError = RetrievingMediaStreamError;
class SFUNewPeersEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUNewPeersEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUNewPeersEventError = SFUNewPeersEventError;
class SFUConsumerSourcesEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUConsumerSourcesEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUConsumerSourcesEventError = SFUConsumerSourcesEventError;
class SFUNewConsumerEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUNewConsumerEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUNewConsumerEventError = SFUNewConsumerEventError;
class SFUPeerClosedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUPeerClosedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUPeerClosedEventError = SFUPeerClosedEventError;
class SFUSwitchConsumerTrackEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUSwitchConsumerTrackEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUSwitchConsumerTrackEventError = SFUSwitchConsumerTrackEventError;
class SFUConsumerClosedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUConsumerClosedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUConsumerClosedEventError = SFUConsumerClosedEventError;
class SFUConsumerPausedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUConsumerPausedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUConsumerPausedEventError = SFUConsumerPausedEventError;
class SFUConsumerResumedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUConsumerResumedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUConsumerResumedEventError = SFUConsumerResumedEventError;
class SFUConsumerScoreEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUConsumerScoreEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUConsumerScoreEventError = SFUConsumerScoreEventError;
class SFUConsumerLayersChangedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUConsumerLayersChangedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUConsumerLayersChangedEventError = SFUConsumerLayersChangedEventError;
class SFUProducerClosedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUProducerClosedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUProducerClosedEventError = SFUProducerClosedEventError;
class SFUProducerPausedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUProducerPausedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUProducerPausedEventError = SFUProducerPausedEventError;
class SFUProducerResumedEventError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.SFUProducerResumedEvent;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.peer),
        };
    }
}
exports.SFUProducerResumedEventError = SFUProducerResumedEventError;
class WSRequestError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.WSRequestError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.internalCall),
        };
    }
}
exports.WSRequestError = WSRequestError;
class MediasoupSetupError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.MediasoupSetupError;
    }
}
exports.MediasoupSetupError = MediasoupSetupError;
class MediaError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.MediaError;
    }
}
exports.MediaError = MediaError;
class TransportStateError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.TransportStateError;
    }
}
exports.TransportStateError = TransportStateError;
class MediaRecorderError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.MediaRecorderError;
    }
}
exports.MediaRecorderError = MediaRecorderError;
class UpdateMSCError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UpdateMSCError;
    }
    aggregates() {
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.msc),
        };
    }
}
exports.UpdateMSCError = UpdateMSCError;
class ChangeMSCDeviceError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.UpdateMSCError;
    }
    aggregates() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            ...super.aggregates(),
            ...(0, log_node_1.extractAggregates)(this.msc),
            prevVideoDeviceId: (_a = this.prevVideoDeviceId) !== null && _a !== void 0 ? _a : "",
            prevVideoDeviceLabel: (_b = this.prevVideoDeviceLabel) !== null && _b !== void 0 ? _b : "",
            failedVideoDeviceId: (_c = this.failedVideoDeviceId) !== null && _c !== void 0 ? _c : "",
            failedVideoDeviceLabel: (_d = this.failedVideoDeviceLabel) !== null && _d !== void 0 ? _d : "",
            prevAudioDeviceId: (_e = this.prevAudioDeviceId) !== null && _e !== void 0 ? _e : "",
            prevAudioDeviceLabel: (_f = this.prevAudioDeviceLabel) !== null && _f !== void 0 ? _f : "",
            failedAudioDeviceId: (_g = this.failedAudioDeviceId) !== null && _g !== void 0 ? _g : "",
            failedAudioDeviceLabel: (_h = this.failedAudioDeviceLabel) !== null && _h !== void 0 ? _h : "",
        };
    }
}
exports.ChangeMSCDeviceError = ChangeMSCDeviceError;
class Mp4BufferError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.Mp4BufferError;
    }
}
exports.Mp4BufferError = Mp4BufferError;
class HandleHlsJsError extends VideoClientErrorDeprecated {
    constructor() {
        super(...arguments);
        this.code = api_1.ErrorCode.HandleHlsJsError;
    }
}
exports.HandleHlsJsError = HandleHlsJsError;
//# sourceMappingURL=errors-deprecated.js.map